import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { useBackground } from './background-context';
import { BackgroundVariant } from './background-layout';

type BackgroundRouteConfigProps = {
  readonly visible?: boolean;
  readonly variant?: BackgroundVariant;
  readonly ellipse1Variant?: BackgroundVariant;
  readonly ellipse2Variant?: BackgroundVariant;
};

const BackgroundRouteConfig = ({ visible, variant, ellipse1Variant, ellipse2Variant }: BackgroundRouteConfigProps) => {
  const { setBackground, resetBackground } = useBackground();

  useEffect(() => {
    setBackground({ visible: visible ?? true, variant, ellipse1Variant, ellipse2Variant });
    return () => resetBackground();
  }, [visible, variant, ellipse1Variant, ellipse2Variant, setBackground, resetBackground]);

  return <Outlet />;
};

export { BackgroundRouteConfig };
